import React, { useEffect, useContext, useState } from "react";
import SlideTextDisplay from "./SlideTextDisplay";
import { PlayerContext } from "../../context/PlayerContext";
import AlertDialog from "../generic/CustomizeAlertDilaog";
import CustomizedNestedList from "../generic/CustomizedNestedList";
import { getMarginTop } from "../../utils/utils";
import {
  COLORS,
  buildDashboardRows,
} from "../../utils/dashboardItem";
import StopLightCircle from "../generic/StopLightCircle";
import { IconButton, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const TextTrack = (props) => {
  const { setShowPlayButton, showFlashAlert, isPlayingFromTrack } =
    useContext(PlayerContext);
  const { playerState } = useContext(PlayerContext);
  const [showDashboardLegend, setShowDashboardLegend] = useState(false);

  useEffect(() => {
    if (
      (props.alertMessage === "" && props.flashTrackId === "") ||
      !showFlashAlert
    ) {
      if (!props.audioURL && !props.debug) {
        if (props.slideTimeout && !props.flashTrack) {
          props.handleSlideTimeOut();
        }
      } else {
        if (props.audioURL !== undefined) {
          if (!props.debug) {
            const clip = document.getElementById("soundclip");
            if (props.slideTimeout && !props.flashTrack) {
              clip.onended = () => {
                props.handleSlideTimeOut();
              };
            }
            const playPromise = clip.play();

            if (playPromise !== undefined) {
              playPromise
                .then(function () {
                  console.debug("Audio play started in Text Track");
                  setShowPlayButton(false);
                  // Automatic playback started!
                })
                .catch(function (error) {
                  console.debug("Audio Play exception in Text Track:", error);
                  setShowPlayButton(true, error);
                });
            }
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.play]);

  const handleGoToFlashTrack = () => {
    props.handleGoToFlashTrack();
  };

  const shouldShowDashboardItems = Boolean(props.showDashboardItems);
  const dashboardRows =
    props.debug && props.dashboardPreview
      ? (props.dashboardPreviewVars || []).map((v) => ({
          id: v.id,
          label: v.name,
          colors: [],
        }))
      : buildDashboardRows(playerState?.vars, playerState?.dashboardRange);

  const showDashboardPanel =
    shouldShowDashboardItems && dashboardRows.length > 0;

  return (
    <>
      {!props.isPub && (
        <h1 style={{ marginTop: getMarginTop(props.isPub, props.trackIdx) }}>
          Track: {props.order} -- {props.title} --{" "}
          {!props.isPub && !props.debug ? props.trackId : props.id}
        </h1>
      )}
      {props.visibilitySettings.length > 0 && isPlayingFromTrack && (
        <CustomizedNestedList
          text="Variables:"
          visibilitySettings={props.visibilitySettings}
        />
      )}
      <h1 style={{ marginTop: getMarginTop(props.isPub, props.trackIdx) }}>
        {props.header}
      </h1>

      <div className="texttrack_content">
        <SlideTextDisplay html={props.body} className="texttrack_text" />
        {showDashboardPanel && (
          <div className="dashboard-overlay dashboard-overlay--inline">
            {dashboardRows.map((row, rowIndex) => (
              <div key={row.id} className="dashboard-overlay__row">
                {showDashboardLegend && (
                  <span className="dashboard-overlay__label">{row.label}</span>
                )}
                {rowIndex === 0 && (
                  <Tooltip title={showDashboardLegend ? "Hide variable names" : "Show variable names"}>
                    <IconButton
                      size="small"
                      onClick={() => setShowDashboardLegend((prev) => !prev)}
                      className="dashboard-overlay__info-btn"
                      aria-label="toggle variable names"
                    >
                      <InfoOutlinedIcon fontSize="small" style={{ color: "#fff" }} />
                    </IconButton>
                  </Tooltip>
                )}
                <span className="dashboard-overlay__lights">
                  {COLORS.map((slotColor) => {
                    const isActive = row.colors.includes(slotColor);
                    return (
                      <StopLightCircle
                        key={`${row.id}-${slotColor}`}
                        color={slotColor}
                        active={isActive}
                      />
                    );
                  })}
                </span>
              </div>
            ))}
          </div>
        )}
        {props.trackImgURL && (
          <div className="imgContainer">
            <img src={props.pubTrackImageUrl} alt={props.title} />
          </div>
        )}
      </div>
      {props.audioURL && (
        <audio
          key={props.file + "_" + props.audioURL}
          id="soundclip"
          controls={props.debug}
          muted={props.isMuted}
        >
          {props.file && <source src={props.file} type="audio/mpeg" />}
          {props.audioURL && (
            <source src={props.pubAudioUrl} type="audio/mpeg" />
          )}
        </audio>
      )}
      {!props.debug &&
        !props.flashTrack &&
        showFlashAlert &&
        props.alertMessage !== "" &&
        props.flashTrackId !== "" && (
          <AlertDialog
            size="lg"
            isSticky={true}
            title={props.alertMessage}
            showGoToFlashTrack={true}
            handleGoToFlashTrack={handleGoToFlashTrack}
          />
        )}
    </>
  );
};

export default TextTrack;
